import Image from 'next/legacy/image'

import Box from '@totallymoney/ui/components/Box'

interface LoansTableImageProps {
    cmsImageUrl: string
    isPortraitImage: boolean
    name: string
}

const LoansTableImage = ({
    name,
    cmsImageUrl,
    isPortraitImage,
}: LoansTableImageProps) => {
    const imageDimensions = !isPortraitImage
        ? { width: 195, height: 98 }
        : { width: 132, height: 208 }

    return (
        <Box
            display="flex"
            width="100%"
            justifyContent={['center', 'flex-start']}
            maxWidth={['unset', '220px']}
        >
            <Image
                src={cmsImageUrl}
                alt={`${name} loan`}
                {...imageDimensions}
            />
        </Box>
    )
}

export default LoansTableImage
